'use client';

/**
 * Gets a cookie value by name
 */
function getCookie(name: string): string | null {
  if (typeof document === 'undefined') return null;

  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);

  if (parts.length === 2) {
    const cookieValue = parts[1]?.split(';')[0];
    return cookieValue !== undefined ? decodeURIComponent(cookieValue) : null;
  }

  return null;
}

/**
 * Sets a cookie with the specified name, value, and configuration
 */
function setCookie(
  name: string,
  value: string,
  options: {
    maxAge?: number;
    path?: string;
    secure?: boolean;
    sameSite?: 'strict' | 'lax' | 'none';
    domain?: string;
  } = {}
): void {
  if (typeof document === 'undefined') return;

  const { maxAge, path = '/', secure = true, sameSite = 'lax', domain } = options;

  let cookieString = `${name}=${encodeURIComponent(value)}`;

  if (maxAge !== undefined) {
    const expires = new Date(Date.now() + maxAge * 1000);
    cookieString += `; expires=${expires.toUTCString()}`;
  }

  if (path) {
    cookieString += `; path=${path}`;
  }

  if (secure) {
    cookieString += `; secure`;
  }

  if (sameSite) {
    cookieString += `; samesite=${sameSite}`;
  }

  if (domain) {
    cookieString += `; domain=${domain}`;
  }
  document.cookie = cookieString;
}

function removeCookie(
  name: string,
  options: {
    path?: string;
    secure?: boolean;
    sameSite?: 'strict' | 'lax' | 'none';
    domain?: string;
  } = {}
): void {
  if (typeof window === 'undefined') return;

  setCookie(name, '', { ...options, maxAge: 0 });
}

export { getCookie, removeCookie, setCookie };
